import { paths } from 'src/routes/paths';

/**
 * 데모 배너 경로·메시지 항목 (`nav-config-service` 사이드바 메뉴 기준)
 * @typedef {Object} DemoBannerItem
 * @property {string|RegExp} path
 * @property {string} message
 */

/**
 * `DEMO_BANNER_MAP`에 해당하는 경로가 없을 때(또는 매칭 실패 시) 표시하는 기본 문구
 */
export const DEMO_BANNER_DEFAULT_MESSAGE = '✨ 현재 데모 서비스를 이용 중이에요!';

/** @param {string} segment */
const escapeRegExp = (segment: string) => segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * 해당 경로로 시작하거나 정확히 일치할 때 매칭 (하위 라우트 포함)
 * @param {string} basePath
 * @returns {RegExp}
 */
const pathPrefixMatch = (basePath: string) =>
  new RegExp(`^${escapeRegExp(basePath)}(?:/|$)`);

/**
 * 경로가 정확히 일치할 때만 매칭
 * @param {string} exactPath
 * @returns {RegExp}
 */
const pathExactMatch = (exactPath: string) => new RegExp(`^${escapeRegExp(exactPath)}$`);

const { service: p } = paths;

/** @type {DemoBannerItem[]} */
export const DEMO_BANNER_MAP = [
  // 긴·구체적 경로를 먼저 (첫 매칭 우선)
  {
    path: pathPrefixMatch(`${p.brand}/set/campaign`),
    message: '📡 관심 키워드가 소셜에서 어떻게 언급되는지 살펴봤어요!',
  },
  {
    path: pathPrefixMatch(p.bookmark.root),
    message: '📌 저장한 포스팅을 목적별로 분류해 한곳에서 관리할 수 있게 정리해봤어요!',
  },
  {
    path: pathPrefixMatch(p.campaign.root),
    message: '📣 롬앤의 시딩 캠페인 성과를 자동 추적해봤어요!',
  },
  {
    path: pathPrefixMatch(p.account),
    message: '👀 롬앤 공식 SNS 계정들의 운영 성과를 진단해 봤어요!',
  },
  {
    path: pathPrefixMatch(p.postBenchmark),
    message: '✨ 롬앤 브랜디드 컨텐츠 성과를 분석해 분석해봤어요!', 
  },
  {
    path: pathPrefixMatch(p.externalDashboard),
    message: '🛒 롬앤 소비자 리뷰 컨텐츠를 자사몰에 연동할 수 있게 준비해봤어요!',
  },
  
  {
    path: pathPrefixMatch(p.trend),
    message: '🏆 제품군별 브랜드 랭킹을 확인해 봤어요!',
  },
  {
    path: pathPrefixMatch(p.search),
    message: '🔍 ‘kbeauty’로 검색된 글로벌 포스팅과 반응을 모아봤어요!',
  },
  {
    path: pathPrefixMatch(p.idea),
    message: '🔥 요즘 뜨는 키워드와 썸네일 트렌드를 찾아왔어요!',
  },
  {
    path: pathPrefixMatch(p.influencer),
    message: '👀 최근 성과가 좋았던 마이크로 인플루언서를 찾아봤어요!',
  },
  {
    path: pathPrefixMatch(p.brand),
    message: '🔍 롬앤을 언급한 모든 포스팅과 반응을 모아봤어요!',
  },
  {
    path: pathExactMatch(p.dashboard),
    message: '📊 오늘 롬앤의 SNS 마케팅 현황과 트렌드를 정리해봤어요!',
  },
  {
    path: pathExactMatch(p.root),
    message: '📊 오늘 롬앤의 SNS 마케팅 현황과 트렌드를 정리해봤어요!',
  },
];
